<template>
  <div>
    <modal
      :show.sync="editRole"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Chapter
      </h6>
      <div>
        <!-- <base-input
          v-model="user.role"
          placeholder="Enter Chapter Name"
          class="cust-mb0"
        ></base-input> -->
        <b-form-group
          id="input-group-3"
          label="Select Role"
          label-for="input-3"
        >
          <b-form-select
            id="input-3"
            v-model="user.role"
            :options="roleOption"
            required
          ></b-form-select>
        </b-form-group>
        <!-- <b-button type="primary"
              >Create Chapter</b-button -->
      </div>
      <template slot="footer">
        <base-button type="primary" @click="changeRole()"
          >EDIT ROLE</base-button
        >
        <base-button @click="closeModal" type="secondary" class="ml-auto"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    editRole: Boolean,
    edit_role: Function,
    singleUserData: Object,
  },
  data() {
    return {
      chapter: {},
      user: {},
      roleOption: [
        // { text: "Select One", value: null },
        { text: "Admin", value: "admin" },
        { text: "Student", value: "student" },
        { text: "User", value: "user" },
        { text: "Intern", value: "intern" },
        { text: "Author", value: "author" },
        { text: "Employee", value: "employee" },
        { text: "Volunteer", value: "volunteer" },
      ],
    };
  },
  methods: {
    async changeRole() {
      // console.log({ user: this.user });
      if (this.user.role.length != 0) {
        try {
          var loader = this.$loading();

          const data = await this.$store.dispatch("admin/UpdateUserDetails", {
            role: this.user.role,
            _id: this.user._id,
          });

          if (data.code == 200) {
            this.$swal.fire({
              title: "Edited",

              text: "Your changes to User role have been saved successfully!",

              icon: "success",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });
            loader.close();
            this.closeModal();
          }
        } catch (err) {
          loader.close();
        }
      }
    },
    closeModal() {
      this.$emit("close-editRole");
    },
  },
  watch: {
    singleUserData(newValue, oldValue) {
      // console.log(newValue);
      this.user = { ...newValue };
    },
  },
  // computed: {
  //   name: {
  //     get() {
  //       return this.chapterId.name;
  //     },
  //     set(newValue) {
  //       console.log(newValue);
  //       return newValue;
  //     },
  //   },
  // },
};
</script>
